import React, { useEffect, useState } from "react";
import "./Gdnav.css";

const NAV_ITEMS = [{ label: "TẤT CẢ SẢN PHẨM", href: "/giadung" }];

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" className="sh-icon" aria-hidden="true">
      <path
        d="M21 21l-4.35-4.35M10.8 18.2a7.4 7.4 0 1 1 0-14.8 7.4 7.4 0 0 1 0 14.8Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Gdnav() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <header className="sh-header">
      <div className="portfolio-logo-row">
          <img src="/logo.png" alt="logo" />
        </div>
      <div className="sh-container sh-row">
        {/* Logo */}
        

        {/* Desktop nav */}
        <nav className="sh-nav sh-desktopOnly" aria-label="Primary">
          <ul className="sh-menu">
            {NAV_ITEMS.map((it) => (
              <li key={it.label} className="sh-menuItem">
                <a
                  className={`sh-link ${it.active ? "is-active" : ""}`}
                  href={it.href}
                >
                  {it.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Desktop search */}
        <form
          className="sh-search sh-desktopOnly"
          onSubmit={(e) => e.preventDefault()}
          role="search"
        >
          <input
            className="sh-searchInput"
            placeholder="Tìm kiếm..."
            type="search"
          />
          <button className="sh-searchBtn" type="submit" aria-label="Search">
            <SearchIcon />
          </button>
        </form>

        {/* Mobile hamburger */}
        <button
          className="sh-burger sh-mobileOnly"
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span className={`sh-burgerLine ${open ? "is-open" : ""}`} />
          <span className={`sh-burgerLine ${open ? "is-open" : ""}`} />
          <span className={`sh-burgerLine ${open ? "is-open" : ""}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      <div className={`sh-drawer sh-mobileOnly ${open ? "is-open" : ""}`}>
        <div className="sh-container">
          <form
            className="sh-search sh-searchMobile"
            onSubmit={(e) => e.preventDefault()}
            role="search"
          >
            <input
              className="sh-searchInput"
              placeholder="Tìm kiếm..."
              type="search"
            />
            <button className="sh-searchBtn" type="submit" aria-label="Search">
              <SearchIcon />
            </button>
          </form>

          <nav aria-label="Mobile Primary">
            <ul className="sh-menu sh-menuMobile">
              {NAV_ITEMS.map((it) => (
                <li key={it.label} className="sh-menuItem">
                  <a
                    className={`sh-link sh-linkMobile ${it.active ? "is-active" : ""}`}
                    href={it.href}
                    onClick={() => setOpen(false)}
                  >
                    {it.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}
